import { render, staticRenderFns } from "./Deckblatt.vue?vue&type=template&id=06649c54&"
import script from "./Deckblatt.vue?vue&type=script&lang=js&"
export * from "./Deckblatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports